import { createFileRoute } from "@tanstack/react-router"

import { CallDetailView } from "@/features/voxsense/components/call-detail-view"

export const Route = createFileRoute("/_shell/voxsense/calls/$callId")({
  // Analysis is the default, so only the transcript shows in the URL.
  validateSearch: (
    search: Record<string, unknown>
  ): { tab?: "transcript" } => ({
    tab: search.tab === "transcript" ? "transcript" : undefined,
  }),
  component: CallDetailRoute,
})

function CallDetailRoute() {
  const { callId } = Route.useParams()
  const { tab } = Route.useSearch()
  const navigate = Route.useNavigate()
  return (
    <CallDetailView
      callId={callId}
      tab={tab ?? "analysis"}
      onTabChange={(next) =>
        void navigate({
          search: { tab: next === "transcript" ? next : undefined },
          replace: true,
          resetScroll: false,
        })
      }
    />
  )
}
